import type { ToggleSwitchDesignTokens, ToggleSwitchTokenSections } from '@primeuix/themes/types/toggleswitch';

// Rebrand 2026 (DS): 2.5rem × 1.5rem pill, grey.200 track, no border
export const root: ToggleSwitchTokenSections.Root = {
    width: '2.5rem',
    height: '1.5rem',
    borderRadius: '{extend.borderRadius.rounded}',
    gap: '0.25rem',
    shadow: 'none',
    focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        offset: '{focusRing.offset}'
    },
    borderWidth: '0',
    borderColor: 'transparent',
    hoverBorderColor: 'transparent',
    checkedBorderColor: 'transparent',
    checkedHoverBorderColor: 'transparent',
    invalidBorderColor: '{formField.invalidBorderColor}',
    transitionDuration: '{transitionDuration}',
    slideDuration: '0.15s'
};

export const handle: ToggleSwitchTokenSections.Handle = {
    borderRadius: '{extend.borderRadius.rounded}',
    size: '1rem'
};

export const colorScheme: ToggleSwitchTokenSections.ColorScheme = {
    light: {
        root: {
            background: '{extend.bordercontrol}',   // off track: 3.5:1 like every control border,
            disabledBackground: '{formField.disabledBackground}',
            hoverBackground: '{text.mutedColor}',
            checkedBackground: '{primary.color}',
            checkedHoverBackground: '{primary.hoverColor}'
        },
        handle: {
            background: '{surface.0}',
            disabledBackground: '{surface.0}',
            hoverBackground: '{surface.0}',
            checkedBackground: '{surface.0}',
            checkedHoverBackground: '{surface.0}',
            color: '{surface.500}',
            hoverColor: '{surface.700}',
            checkedColor: '{surface.0}',
            checkedHoverColor: '{surface.0}'
        }
    },
    dark: {
        root: {
            background: '{surface.700}',
            disabledBackground: '{formField.disabledBackground}',
            hoverBackground: '{surface.600}',
            checkedBackground: '{primary.color}',
            checkedHoverBackground: '{primary.hoverColor}'
        },
        handle: {
            background: '{surface.400}',
            disabledBackground: '{surface.900}',
            hoverBackground: '{surface.300}',
            checkedBackground: '{surface.900}',
            checkedHoverBackground: '{surface.900}',
            color: '{surface.400}',
            hoverColor: '{surface.300}',
            checkedColor: '{primary.color}',
            checkedHoverColor: '{primary.hoverColor}'
        }
    }
};

export default {
    root,
    handle,
    colorScheme
} satisfies ToggleSwitchDesignTokens;
